import { render } from "./LocationsList.vue?vue&type=template&id=7160df75"
import script from "./LocationsList.vue?vue&type=script&lang=js"
export * from "./LocationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__